import { Collection } from 'modules/core/lib/mobx-rest'

import QuestionsTemplate from 'modules/surveys/store/models/QuestionsTemplate'

class QuestionsTemplates extends Collection<QuestionsTemplate> {
  get cacheKey(): string {
    return 'surveysQuestionsTemplates'
  }
  model() {
    return QuestionsTemplate
  }
}

const questionsTemplate: QuestionsTemplates = new QuestionsTemplates()

export default questionsTemplate
